export default __webpack_public_path__ + "static/media/loader.c16e72e7.png";